export function isEmptyObject(object: any): boolean {
  if (!object) {
    return true;
  }

  if (Object.keys(object).length === 0) {
    return true;
  }

  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      const element = object[key];
      if (element !== undefined) {
        return false;
      }
    }
  }

  return true;
}
